import React from 'react';
import { Container, Typography, Box, Paper, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import SecurityIcon from '@mui/icons-material/Security';

const Privacidade: React.FC = () => {
  return (
    <Box sx={{ minHeight: '80vh', py: 4, backgroundColor: '#f8f9fa' }}>
      <Container maxWidth="md">
        <Breadcrumbs sx={{ mb: 3 }}>
          <MuiLink component={Link} to="/" color="inherit" underline="hover">
            Início
          </MuiLink>
          <Typography color="text.primary">Política de Privacidade</Typography>
        </Breadcrumbs>

        <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: '1px solid #e0e0e0' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: '12px',
                bgcolor: 'rgba(194, 53, 53, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#C23535',
              }}
            >
              <SecurityIcon sx={{ fontSize: 28 }} />
            </Box>
            <Box>
              <Typography variant="h4" component="h1" fontWeight={700} color="#202529">
                Política de Privacidade
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Última atualização: Setembro de 2026 • Em conformidade com a LGPD (Lei nº 13.709/2018)
              </Typography>
            </Box>
          </Box>

          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            O <strong>IDECONECTA</strong>, mantido pelo <strong>IDEBRASIL</strong>, tem o compromisso de proteger a privacidade e os dados pessoais de seus membros, alunos e empresas parceiras. Esta Política de Privacidade descreve como coletamos, utilizamos, armazenamos e protegemos suas informações na plataforma web e em nossos aplicativos móveis (iOS e Android).
          </Typography>

          <Typography variant="h6" fontWeight={700} sx={{ mt: 4, mb: 1, color: '#202529' }}>
            1. Dados Pessoais Coletados
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            Para garantir a integridade da rede empresarial exclusiva do IDEBRASIL, coletamos os seguintes dados:
          </Typography>
          <ul>
            <li><strong>Identificação e Acesso:</strong> Nome completo, CPF, número de telefone celular e endereço de e-mail corporativo ou pessoal.</li>
            <li><strong>Dados Empresariais:</strong> Razão Social, Nome Fantasia, CNPJ, endereço completo, categoria de atuação, descrição de produtos/serviços, links para website e redes sociais.</li>
            <li><strong>Mídias e Arquivos:</strong> Logomarca e imagens fornecidas para compor o catálogo de empresas parceiras.</li>
          </ul>

          <Typography variant="h6" fontWeight={700} sx={{ mt: 4, mb: 1, color: '#202529' }}>
            2. Finalidade do Tratamento de Dados
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            Os dados coletados têm por finalidade exclusiva:
          </Typography>
          <ul>
            <li>Autenticação de empresários e validação contra a base de membros e alunos do IDEBRASIL;</li>
            <li>Exibição pública no catálogo de empresas para geração de novos negócios entre participantes da rede;</li>
            <li>Envio de comunicações institucionais, avisos de aprovação de perfil e oportunidades de negócios;</li>
            <li>Cumprimento de obrigações legais e regulatórias.</li>
          </ul>

          <Typography variant="h6" fontWeight={700} sx={{ mt: 4, mb: 1, color: '#202529' }}>
            3. Compartilhamento de Informações
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            O IDECONECTA <strong>não comercializa, aluga ou compartilha</strong> dados pessoais ou bancários com terceiros para fins publicitários. As informações corporativas públicas (Nome Fantasia, categoria, telefone de contato e endereço) ficam visíveis apenas para os usuários que consultam a lista de empresas parceiras com o objetivo de realizar parcerias comerciais.
          </Typography>

          <Typography variant="h6" fontWeight={700} sx={{ mt: 4, mb: 1, color: '#202529' }}>
            4. Segurança e Armazenamento
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            Adotamos medidas técnicas e organizacionais adequadas para proteger os dados contra acessos não autorizados, perda, destruição ou alteração, incluindo criptografia SSL/TLS em todas as comunicações, controle de acessos restrito por perfil de administrador e servidores seguros.
          </Typography>

          <Typography variant="h6" fontWeight={700} sx={{ mt: 4, mb: 1, color: '#202529' }}>
            5. Direitos do Titular e Exclusão de Dados
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            Em conformidade com o artigo 18 da LGPD e as diretrizes da Apple App Store e Google Play Store, o titular dos dados tem o direito de solicitar a qualquer momento: confirmação do tratamento, acesso aos dados, correção de dados incompletos ou a <strong>exclusão total de sua conta e informações pessoais</strong>.
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            Para excluir sua conta e seus dados, você pode utilizar o botão <em>"Excluir Conta"</em> no seu painel ou acessar a página de <MuiLink component={Link} to="/excluir-conta" color="primary" fontWeight={600}>Solicitação de Exclusão de Conta</MuiLink>.
          </Typography>

          <Typography variant="h6" fontWeight={700} sx={{ mt: 4, mb: 1, color: '#202529' }}>
            6. Contato com o Encarregado de Dados (DPO)
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            Para tirar dúvidas ou exercer seus direitos de privacidade, entre em contato pelo e-mail: <strong>contato@idebrasil.com.br</strong> ou acesse a página de <MuiLink component={Link} to="/suporte" color="primary" fontWeight={600}>Suporte</MuiLink>.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Privacidade;
